import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import MyLoader from "../Spinner/MyLoader";
import COLORS from "../resources/colors/COLORS";
import SessionManager from "../Utils/SessionManager";
import { Redirect, useParams, useHistory, Link, useLocation } from "react-router-dom";
import "../css/Admin_css/admin-customize.css";
import myToast from "../Utils/MyToast";
import { Button } from "react-bootstrap";
import MdlSelectSession from "../dialog/MdlSelectSession";
import BackButton from "../ChildComponent/BackButton";

const FeeCard = () => {
  const history = useHistory();
  const location = useLocation();
  const { enrollment_no, session_id } = useParams();
  
  // Also check query params as fallback
  const queryParams = new URLSearchParams(location.search);
  const enrollmentFromQuery = queryParams.get("enrollment_no") || queryParams.get("enrollment");
  const sessionFromQuery = queryParams.get("session_id") || queryParams.get("session");
  
  const [loggedIn, setLoggedIn] = useState(!!localStorage.getItem("token"));
  const [Loading, setLoading] = useState(false);
  const [mStudentDetails, setMStudentDetails] = useState([]);
  const [mFeeCard, setMFeeCard] = useState([]);
  
  // Initialize with params, query params, or try localStorage
  const getInitialEnrollment = () => {
    if (enrollment_no) return enrollment_no;
    if (enrollmentFromQuery) return enrollmentFromQuery;
    try {
      const selectedStudent = localStorage.getItem("SelectedStudent");
      if (selectedStudent) {
        const student = JSON.parse(selectedStudent);
        return student.student_enrollment_no || "";
      }
    } catch (e) {
      console.error("Error parsing selected student:", e);
    }
    return "";
  };
  
  const getInitialSession = () => {
    if (session_id) return session_id;
    if (sessionFromQuery) return sessionFromQuery;
    const mSession = SessionManager.getCurrentSession();
    if (mSession && mSession.length > 0) {
      return mSession[0].session_id;
    }
    return "";
  };
  
  const [ENROLLMENT_NO, setENROLLMENT_NO] = useState(getInitialEnrollment());
  const [SESSION_ID, setSESSION_ID] = useState(getInitialSession());
  const [SESSION_NAME, setSESSION_NAME] = useState(() => {
    const mSession = SessionManager.getCurrentSession();
    if (mSession && mSession.length > 0) {
      return mSession[0].session_name || "";
    }
    return "";
  });
  const [isOpenSessionDialog, setIsOpenSessionDialog] = useState(false);
  const [totalFee, setTotalFee] = useState(0);
  const [totalPaid, setTotalPaid] = useState(0);
  const [totalDue, setTotalDue] = useState(0);

  // Add axios interceptor to log all requests
  useEffect(() => {
    const requestInterceptor = axios.interceptors.request.use(
      (config) => {
        if (config.url && config.url.includes("getStudentFeeCard")) {
          console.log("=== AXIOS REQUEST INTERCEPTOR ===");
          console.log("Request URL =>", config.url);
          console.log("Request Base URL =>", config.baseURL);
          console.log("Request Full URL =>", `${config.baseURL || ""}${config.url}`);
          console.log("Request Params =>", config.params);
          console.log("Request Method =>", config.method);
          console.log("=================================");
        }
        return config;
      },
      (error) => {
        console.log("Axios Request Error =>", error);
        return Promise.reject(error);
      }
    );

    const responseInterceptor = axios.interceptors.response.use(
      (response) => {
        if (response.config.url && response.config.url.includes("getStudentFeeCard")) {
          console.log("=== AXIOS RESPONSE INTERCEPTOR ===");
          console.log("Response URL =>", response.config.url);
          console.log("Response Status =>", response.status);
          console.log("Response Data =>", response.data);
          console.log("==================================");
        }
        return response;
      },
      (error) => {
        if (error.config?.url && error.config.url.includes("getStudentFeeCard")) {
          console.log("=== AXIOS RESPONSE ERROR INTERCEPTOR ===");
          console.log("Error URL =>", error.config.url);
          console.log("Error =>", error);
          console.log("=========================================");
        }
        return Promise.reject(error);
      }
    );

    return () => {
      axios.interceptors.request.eject(requestInterceptor);
      axios.interceptors.response.eject(responseInterceptor);
    };
  }, []);

  useEffect(() => {
    console.log("=== FeeCard Component Mount/Update ===");
    console.log("enrollment_no param =>", enrollment_no);
    console.log("session_id param =>", session_id);
    console.log("enrollmentFromQuery =>", enrollmentFromQuery);
    console.log("sessionFromQuery =>", sessionFromQuery);
    console.log("Current ENROLLMENT_NO state =>", ENROLLMENT_NO);
    console.log("Current SESSION_ID state =>", SESSION_ID);
    
    window.scrollTo(0, 0);
    
    // Set ENROLLMENT_NO: Priority: URL param > query param > existing state > localStorage > student details
    const finalEnrollment = enrollment_no || enrollmentFromQuery;
    if (finalEnrollment && finalEnrollment !== ENROLLMENT_NO) {
      console.log("Setting ENROLLMENT_NO from URL/Query =>", finalEnrollment);
      setENROLLMENT_NO(finalEnrollment);
    } else if (!ENROLLMENT_NO) {
      // Try to get from localStorage
      const selectedStudent = localStorage.getItem("SelectedStudent");
      console.log("SelectedStudent from localStorage =>", selectedStudent);
      if (selectedStudent) {
        try {
          const student = JSON.parse(selectedStudent);
          console.log("Parsed student from localStorage =>", student);
          if (student.student_enrollment_no) {
            setENROLLMENT_NO(student.student_enrollment_no);
            console.log("Set ENROLLMENT_NO from localStorage =>", student.student_enrollment_no);
          }
        } catch (e) {
          console.error("Error parsing selected student:", e);
        }
      }
      
      // Also try to get from mStudentDetails if available
      if (mStudentDetails && mStudentDetails.length > 0 && mStudentDetails[0].student_enrollment_no) {
        const enrollmentFromDetails = mStudentDetails[0].student_enrollment_no;
        console.log("Setting ENROLLMENT_NO from mStudentDetails =>", enrollmentFromDetails);
        setENROLLMENT_NO(enrollmentFromDetails);
      }
    }
    
    // Set SESSION_ID: Priority: URL param > query param > existing state > current session
    const finalSession = session_id || sessionFromQuery;
    if (finalSession && finalSession !== SESSION_ID) {
      console.log("Setting SESSION_ID from URL/Query =>", finalSession);
      setSESSION_ID(finalSession);
    } else if (!SESSION_ID) {
      const mSession = SessionManager.getCurrentSession();
      console.log("Current Session =>", mSession);
      if (mSession && mSession.length > 0) {
        setSESSION_ID(mSession[0].session_id);
        setSESSION_NAME(mSession[0].session_name);
        console.log("Set SESSION_ID =>", mSession[0].session_id);
        console.log("Set SESSION_NAME =>", mSession[0].session_name);
      }
    }
    console.log("======================================");
  }, [enrollment_no, session_id, enrollmentFromQuery, sessionFromQuery]);

  const getFeeCard = useCallback(() => {
    console.log("=== FeeCard getFeeCard CALLED ===");
    console.log("FeeCard: ENROLLMENT_NO =>", ENROLLMENT_NO);
    console.log("FeeCard: SESSION_ID =>", SESSION_ID);

    if (!ENROLLMENT_NO || !SESSION_ID) {
      console.log("FeeCard: Missing enrollment_no or session_id", {
        ENROLLMENT_NO,
        SESSION_ID,
      });
      return;
    }

    setLoading(true);
    const SCHOOL_CODE = SessionManager.getSchoolCode();
    const FUNCTION_NAME = "getStudentFeeCard.php?";
    const BASE_URL =
      process.env.REACT_APP_SERVER_NAME +
      process.env.REACT_APP_TARGET_DIR +
      FUNCTION_NAME;

    const params = {
      school_code: SCHOOL_CODE,
      session_id: SESSION_ID,
      enrollment_no: ENROLLMENT_NO,
    };

    const queryString = new URLSearchParams(params).toString();
    const FULL_URL = `${BASE_URL}${queryString}`;
    
    console.log("=== FeeCard API CALL DETAILS ===");
    console.log("FeeCard BASE_URL =>", BASE_URL);
    console.log("FeeCard API Params =>", params);
    console.log("FeeCard FULL URL =>", FULL_URL);
    console.log("FeeCard SCHOOL_CODE =>", SCHOOL_CODE);
    console.log("=================================");

    axios
      .get(BASE_URL, {
        params: params,
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
        },
      })
      .then((res) => {
        console.log("=== FeeCard API SUCCESS ===");
        console.log("FeeCard API Response =>", res);
        console.log("FeeCard API Response Data =>", res.data);
        console.log("FeeCard API Status =>", res.data?.api_status);
        return res.data;
      })
      .then((response) => {
        setLoading(false);
        if (response.api_status === "OK") {
          const studentDetails = response.data?.student_details || [];
          const feeDetails = response.data?.fee_details || [];

          console.log("FeeCard Student Details =>", studentDetails);
          console.log("FeeCard Fee Details =>", feeDetails);

          setMStudentDetails(studentDetails);
          setMFeeCard(feeDetails);
          
          // Update ENROLLMENT_NO from student details if it was missing
          if (!ENROLLMENT_NO && studentDetails.length > 0 && studentDetails[0].student_enrollment_no) {
            console.log("FeeCard: Updating ENROLLMENT_NO from API response =>", studentDetails[0].student_enrollment_no);
            setENROLLMENT_NO(studentDetails[0].student_enrollment_no);
          }

          // Calculate totals
          let totalFeeAmount = 0;
          let totalPaidAmount = 0;
          let totalDueAmount = 0;

          feeDetails.forEach((monthData) => {
            let applicableFee = monthData.applicable_fee || [];
            // Handle case where applicable_fee might be a JSON string
            if (typeof applicableFee === "string") {
              try {
                applicableFee = JSON.parse(applicableFee);
              } catch (e) {
                console.error("Error parsing applicable_fee:", e);
                applicableFee = [];
              }
            }
            if (Array.isArray(applicableFee)) {
              applicableFee.forEach((fee) => {
                totalFeeAmount += parseFloat(fee.fee_value || 0);
                totalPaidAmount += parseFloat(fee.amount_paid || 0);
                totalDueAmount += parseFloat(fee.outstanding || 0);
              });
            }
          });

          setTotalFee(totalFeeAmount);
          setTotalPaid(totalPaidAmount);
          setTotalDue(totalDueAmount);
        } else {
          myToast.notify_warning(response.api_remark || "Failed to fetch fee card");
        }
      })
      .catch((error) => {
        setLoading(false);
        console.log("=== FeeCard API ERROR ===");
        console.log("FeeCard API Error =>", error);
        console.log("FeeCard Error Message =>", error.message);
        console.log("FeeCard Error Response =>", error.response);
        console.log("FeeCard Error Response Data =>", error.response?.data);
        console.log("FeeCard Error Status =>", error.response?.status);
        console.log("FeeCard Error URL =>", error.config?.url);
        console.log("FeeCard Error Params =>", error.config?.params);
        console.log("==========================");
        myToast.notify_error("Error fetching fee card details");
      });
  }, [ENROLLMENT_NO, SESSION_ID]);

  // Call API when both values are available
  useEffect(() => {
    console.log("=== FeeCard useEffect TRIGGERED ===");
    console.log("FeeCard: ENROLLMENT_NO =>", ENROLLMENT_NO);
    console.log("FeeCard: SESSION_ID =>", SESSION_ID);
    console.log("FeeCard: enrollment_no param =>", enrollment_no);
    console.log("FeeCard: session_id param =>", session_id);
    console.log("FeeCard: enrollmentFromQuery =>", enrollmentFromQuery);
    console.log("FeeCard: sessionFromQuery =>", sessionFromQuery);
    
    // Update ENROLLMENT_NO if we have it from params/query but state is empty
    if (!ENROLLMENT_NO) {
      const finalEnrollment = enrollment_no || enrollmentFromQuery;
      if (finalEnrollment) {
        console.log("FeeCard: Setting ENROLLMENT_NO from params/query =>", finalEnrollment);
        setENROLLMENT_NO(finalEnrollment);
        return; // Will trigger this effect again with new ENROLLMENT_NO
      }
      
      // Try localStorage
      try {
        const selectedStudent = localStorage.getItem("SelectedStudent");
        if (selectedStudent) {
          const student = JSON.parse(selectedStudent);
          if (student.student_enrollment_no) {
            console.log("FeeCard: Setting ENROLLMENT_NO from localStorage =>", student.student_enrollment_no);
            setENROLLMENT_NO(student.student_enrollment_no);
            return;
          }
        }
      } catch (e) {
        console.error("Error parsing selected student:", e);
      }
    }
    
    // Update SESSION_ID if we have it from params/query but state is empty
    if (!SESSION_ID) {
      const finalSession = session_id || sessionFromQuery;
      if (finalSession) {
        console.log("FeeCard: Setting SESSION_ID from params/query =>", finalSession);
        setSESSION_ID(finalSession);
        return; // Will trigger this effect again with new SESSION_ID
      }
      
      // Try current session
      const mSession = SessionManager.getCurrentSession();
      if (mSession && mSession.length > 0) {
        console.log("FeeCard: Setting SESSION_ID from current session =>", mSession[0].session_id);
        setSESSION_ID(mSession[0].session_id);
        setSESSION_NAME(mSession[0].session_name || "");
        return;
      }
    }
    
    // Call API if both are available
    if (ENROLLMENT_NO && SESSION_ID) {
      console.log("FeeCard: ✅ Both values present, calling API...");
      getFeeCard();
    } else {
      console.log("FeeCard: ⏳ Waiting for enrollment_no and session_id", {
        ENROLLMENT_NO,
        SESSION_ID,
      });
    }
    console.log("===================================");
  }, [ENROLLMENT_NO, SESSION_ID, getFeeCard, enrollment_no, session_id, enrollmentFromQuery, sessionFromQuery]);

  const HandleShowSessionDialog = () => {
    setIsOpenSessionDialog(true);
  };

  const HandleCloseSessionDialog = () => {
    setIsOpenSessionDialog(false);
  };

  const HandleSelectedSession = (session_id, session_name) => {
    setSESSION_ID(session_id);
    setSESSION_NAME(session_name);
    setIsOpenSessionDialog(false);
    getFeeCard();
  };

  const getCurrentMonth = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = today.getMonth() + 1;
    return `${year}-${month.toString().padStart(2, "0")}`;
  };

  const getCardColor = (month, dueAmount) => {
    const currentMonth = getCurrentMonth();
    if (dueAmount === 0) {
      return {
        container: "#d1fae5",
        header: "#10b981",
        text: "#065f46",
      };
    } else if (month > currentMonth) {
      return {
        container: "#dbeafe",
        header: "#3b82f6",
        text: "#1e40af",
      };
    } else {
      return {
        container: "#fee2e2",
        header: "#ef4444",
        text: "#991b1b",
      };
    }
  };

  if (!loggedIn) {
    return <Redirect to="/Login" />;
  }

  if (Loading) {
    return <MyLoader />;
  }

  const studentInfo = mStudentDetails[0] || {};
  const monthGroups = {};

  // Group fees by month
  mFeeCard.forEach((fee) => {
    const month = fee.month || fee.month2 || "Unknown";
    if (!monthGroups[month]) {
      monthGroups[month] = [];
    }
    monthGroups[month].push(fee);
  });

  const months = Object.keys(monthGroups).sort();

        return (
    <div className="content">
      <div
        className="content-header"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div className="leftside-content-header">
          <ul className="breadcrumbs">
            <li>
              <i className="fa fa-home" aria-hidden="true" />
              <a href="#"> Fee Card </a>
            </li>
          </ul>
        </div>
        <div style={{ marginLeft: "auto" }}>
          <BackButton />
        </div>
      </div>

      <div
        className="bg_page_white_rounded box_shadow animated fadeInUp"
        style={{
          "--mMargin": "30px",
          padding: 0,
          overflow: "hidden",
          borderRadius: "14px",
        }}
      >
        {/* Gradient Header */}
        <div
          className="d-flex align-items-center justify-content-between"
          style={{
            background: "linear-gradient(135deg, #0d6efd, #6610f2, #ff7b54)",
            borderRadius: "14px 14px 0 0",
            padding: "14px 20px",
            boxShadow: "0 10px 25px rgba(15, 23, 42, 0.25)",
            color: "#fff",
          }}
        >
          <div className="d-flex align-items-center gap-2">
            <span
              className="d-inline-flex align-items-center justify-content-center rounded-circle"
              style={{
                width: 40,
                height: 40,
                backgroundColor: "rgba(255,255,255,0.18)",
              }}
            >
              <i className="fa fa-credit-card" />
            </span>
            <div>
              <h5 className="mb-0" style={{ fontWeight: 600 }}>
                Student Fee Card
              </h5>
              <small style={{ opacity: 0.9 }}>
                View complete fee details month by month.
              </small>
            </div>
          </div>
        </div>

        <div style={{ padding: "20px 24px 24px 24px" }}>
          {/* Show message if enrollment_no is missing and not loading */}
          {!ENROLLMENT_NO && !Loading && mFeeCard.length === 0 && (
            <div
              style={{
                background: "#fef3c7",
                borderRadius: "12px",
                padding: "20px",
                marginBottom: "20px",
                border: "2px solid #f59e0b",
                textAlign: "center",
              }}
            >
              <i
                className="fa fa-exclamation-triangle"
                style={{ fontSize: "48px", color: "#f59e0b", marginBottom: "16px" }}
              />
              <h5 style={{ color: "#92400e", marginBottom: "8px" }}>
                Student Enrollment Number Required
              </h5>
              <p style={{ color: "#78350f", marginBottom: "16px" }}>
                Please select a student from Fee Collection page to view the fee card.
              </p>
              <Link
                to="/AdminMain/FeeCollection"
                style={{ textDecoration: "none" }}
              >
                <Button
                  variant="warning"
                  style={{
                    padding: "10px 20px",
                    fontSize: "16px",
                    borderRadius: "10px",
                  }}
                >
                  <i className="fa fa-arrow-left me-2" />
                  Go to Fee Collection
                </Button>
              </Link>
            </div>
          )}

          {/* Student Information */}
          {studentInfo.student_enrollment_no && (
            <div
              style={{
                background: "#f8f9fa",
                borderRadius: "12px",
                padding: "20px",
                marginBottom: "20px",
                border: "1px solid #e5e7eb",
              }}
            >
              <div className="row align-items-center">
                <div className="col-md-2 text-center">
                  <img
                    src={studentInfo.student_img_path || "/default-avatar.png"}
                    alt={studentInfo.stu_name}
                    style={{
                      width: "100px",
                      height: "100px",
                      borderRadius: "50%",
                      objectFit: "cover",
                      border: "3px solid #fff",
                      boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                    }}
                  />
                </div>
                <div className="col-md-8">
                  <h4 style={{ margin: "0 0 8px 0", fontWeight: 600 }}>
                    {studentInfo.stu_name}
                  </h4>
                  <p style={{ margin: "4px 0", color: "#6b7280", fontSize: "14px" }}>
                    <strong>Enrollment:</strong> {studentInfo.student_enrollment_no} |{" "}
                    <strong>Roll No:</strong> {studentInfo.student_roll_no || "N/A"}
                  </p>
                  <p style={{ margin: "4px 0", color: "#6b7280", fontSize: "14px" }}>
                    {studentInfo.gender === "Male"
                      ? "S/O"
                      : studentInfo.gender === "Female"
                      ? "D/O"
                      : ""}{" "}
                    <strong>{studentInfo.father_name}</strong> |{" "}
                    <strong>Board:</strong> {studentInfo.board_name || "N/A"} |{" "}
                    <strong>Medium:</strong> {studentInfo.medium_name || "N/A"}
                  </p>
                  <p style={{ margin: "4px 0", color: "#6b7280", fontSize: "14px" }}>
                    <strong>Class:</strong> {studentInfo.class_name || "N/A"}
                    {studentInfo.section_name &&
                      studentInfo.section_name !== "No" &&
                      ` - ${studentInfo.section_name}`}
                  </p>
                </div>
                <div className="col-md-2 text-end">
                  <Button
                    variant="outline-primary"
                    size="sm"
                    onClick={() => {
                      history.push(
                        `/AdminMain/FeeCollection?enrollment=${ENROLLMENT_NO}`
                      );
                    }}
                    style={{ marginBottom: "8px" }}
                  >
                    <i className="fa fa-money-bill-wave me-1" />
                    Collect Fee
                  </Button>
                </div>
              </div>
            </div>
          )}

          {/* Session Selector */}
          <div
            style={{
              background: "#f0f9ff",
              borderRadius: "8px",
              padding: "12px 16px",
              marginBottom: "20px",
              border: "1px solid #bae6fd",
            }}
          >
            <div className="d-flex justify-content-between align-items-center">
            <div>
                <strong>Session:</strong> {SESSION_NAME || "Not Selected"}
              </div>
              <Button
                variant="outline-primary"
                size="sm"
                onClick={HandleShowSessionDialog}
              >
                <i className="fa fa-exchange-alt me-1" />
                Change Session
              </Button>
            </div>
          </div>

          {/* Summary Cards */}
          <div className="row mb-4">
            <div className="col-md-4">
              <div
                style={{
                  background: "linear-gradient(135deg, #3b82f6, #2563eb)",
                  borderRadius: "12px",
                  padding: "20px",
                  color: "#fff",
                  boxShadow: "0 4px 12px rgba(59, 130, 246, 0.3)",
                }}
              >
                <div style={{ fontSize: "14px", opacity: 0.9, marginBottom: "8px" }}>
                  Total Fee
                </div>
                <div style={{ fontSize: "28px", fontWeight: 700 }}>
                  ₹{totalFee.toFixed(2)}
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div
                style={{
                  background: "linear-gradient(135deg, #10b981, #059669)",
                  borderRadius: "12px",
                  padding: "20px",
                  color: "#fff",
                  boxShadow: "0 4px 12px rgba(16, 185, 129, 0.3)",
                }}
              >
                <div style={{ fontSize: "14px", opacity: 0.9, marginBottom: "8px" }}>
                  Total Paid
                </div>
                <div style={{ fontSize: "28px", fontWeight: 700 }}>
                  ₹{totalPaid.toFixed(2)}
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div
                style={{
                  background: "linear-gradient(135deg, #ef4444, #dc2626)",
                  borderRadius: "12px",
                  padding: "20px",
                  color: "#fff",
                  boxShadow: "0 4px 12px rgba(239, 68, 68, 0.3)",
                }}
              >
                <div style={{ fontSize: "14px", opacity: 0.9, marginBottom: "8px" }}>
                  Total Due
                </div>
                <div style={{ fontSize: "28px", fontWeight: 700 }}>
                  ₹{totalDue.toFixed(2)}
                </div>
              </div>
            </div>
            </div>

          {/* Monthwise Fee Cards */}
          {months.length > 0 ? (
            <div>
              {months.map((month) => {
                const monthFees = monthGroups[month];
                let monthTotalFee = 0;
                let monthTotalPaid = 0;
                let monthTotalDue = 0;
                const applicableFees = [];

                monthFees.forEach((fee) => {
                  let applicableFee = fee.applicable_fee || [];
                  // Handle case where applicable_fee might be a JSON string
                  if (typeof applicableFee === "string") {
                    try {
                      applicableFee = JSON.parse(applicableFee);
                    } catch (e) {
                      console.error("Error parsing applicable_fee:", e);
                      applicableFee = [];
                    }
                  }
                  if (Array.isArray(applicableFee)) {
                    applicableFee.forEach((f) => {
                      monthTotalFee += parseFloat(f.fee_value || 0);
                      monthTotalPaid += parseFloat(f.amount_paid || 0);
                      monthTotalDue += parseFloat(f.outstanding || 0);
                      applicableFees.push(f);
                    });
                  }
                });

                const colors = getCardColor(month, monthTotalDue);

                return (
                  <div
                    key={month}
                    style={{
                      background: colors.container,
                      borderRadius: "12px",
                      padding: "20px",
                      marginBottom: "20px",
                      border: `2px solid ${colors.header}`,
                      boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                    }}
                  >
                    {/* Month Header */}
                    <div
                      style={{
                        background: colors.header,
                        borderRadius: "8px 8px 0 0",
                        padding: "12px 16px",
                        margin: "-20px -20px 16px -20px",
                        color: "#fff",
                      }}
                    >
                      <h5 style={{ margin: 0, fontWeight: 600 }}>{month}</h5>
                    </div>

                    {/* Month Summary */}
                    <div className="row mb-3">
                      <div className="col-md-4">
                        <div style={{ textAlign: "center" }}>
                          <div style={{ fontSize: "12px", color: colors.text, marginBottom: "4px" }}>
                            Total Fee
                          </div>
                          <div
                            style={{
                              fontSize: "20px",
                              fontWeight: 700,
                              color: colors.text,
                            }}
                          >
                            ₹{monthTotalFee.toFixed(2)}
                          </div>
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div style={{ textAlign: "center" }}>
                          <div style={{ fontSize: "12px", color: colors.text, marginBottom: "4px" }}>
                            Total Paid
                          </div>
                          <div
                            style={{
                              fontSize: "20px",
                              fontWeight: 700,
                              color: colors.text,
                            }}
                          >
                            ₹{monthTotalPaid.toFixed(2)}
                          </div>
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div style={{ textAlign: "center" }}>
                          <div style={{ fontSize: "12px", color: colors.text, marginBottom: "4px" }}>
                            Total Due
                          </div>
                          <div
                            style={{
                              fontSize: "20px",
                              fontWeight: 700,
                              color: colors.text,
                            }}
                          >
                            ₹{monthTotalDue.toFixed(2)}
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Fee Details Table */}
                    {applicableFees.length > 0 && (
                      <div className="table-responsive">
                        <table className="table" style={{ marginBottom: 0 }}>
                          <thead>
                            <tr style={{ background: "rgba(255,255,255,0.5)" }}>
                              <th style={{ padding: "12px", fontWeight: 600, color: colors.text }}>
                                Fee Name
                              </th>
                              <th style={{ padding: "12px", fontWeight: 600, color: colors.text }}>
                                Fee Amount
                              </th>
                              <th style={{ padding: "12px", fontWeight: 600, color: colors.text }}>
                                Paid Amount
                              </th>
                              <th style={{ padding: "12px", fontWeight: 600, color: colors.text }}>
                                Outstanding
                              </th>
                              <th style={{ padding: "12px", fontWeight: 600, color: colors.text }}>
                                Status
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {applicableFees.map((fee, idx) => {
                              const feeAmount = parseFloat(fee.fee_value || 0);
                              const paidAmount = parseFloat(fee.amount_paid || 0);
                              const outstanding = parseFloat(fee.outstanding || 0);
                              const isPaid = fee.payment_status === "Paid" || paidAmount >= feeAmount;

                              return (
                                <tr key={idx}>
                                  <td style={{ padding: "12px", fontWeight: 500 }}>
                                    {fee.fee_name}
                                  </td>
                                  <td style={{ padding: "12px" }}>₹{feeAmount.toFixed(2)}</td>
                                  <td style={{ padding: "12px" }}>₹{paidAmount.toFixed(2)}</td>
                                  <td
                                    style={{
                                      padding: "12px",
                                      color: outstanding > 0 ? "#dc2626" : "#059669",
                                      fontWeight: 600,
                                    }}
                                  >
                                    ₹{outstanding.toFixed(2)}
                                  </td>
                                  <td style={{ padding: "12px" }}>
                                    <span
                                      style={{
                                        padding: "4px 12px",
                                        borderRadius: "12px",
                                        fontSize: "12px",
                                        fontWeight: 600,
                                        background: isPaid ? "#d1fae5" : "#fee2e2",
                                        color: isPaid ? "#065f46" : "#991b1b",
                                      }}
                                    >
                                      {isPaid ? "Paid" : fee.payment_status || "Pending"}
                                    </span>
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          ) : (
            <div
              style={{
                textAlign: "center",
                padding: "60px 20px",
                color: "#6b7280",
              }}
            >
              <i
                className="fa fa-inbox"
                style={{ fontSize: "48px", marginBottom: "16px", opacity: 0.5 }}
              />
              <p style={{ fontSize: "16px", margin: 0 }}>
                No fee details found for this student.
              </p>
            </div>
          )}
        </div>
      </div>

      {isOpenSessionDialog && (
        <MdlSelectSession
          action={HandleCloseSessionDialog}
          action2={HandleSelectedSession}
        />
      )}
    </div>
  );
};

export default FeeCard;
